export const valueLabels = {
  super_admin: 'Super admin',
  admin: 'Admin',
  support: 'Support',
  active: 'Actif',
  inactive: 'Inactif',
  archived: 'Archivé',
  draft: 'Brouillon',
  published: 'Publié',
  pending: 'En attente',
  revoked: 'Révoqué',
  todo: 'À faire',
  in_progress: 'En cours',
  inProgress: 'En cours',
  done: 'Terminé',
  completed: 'Terminé',
  paid: 'Payé',
  unpaid: 'Non payé',
  overdue: 'En retard',
  tuition: 'Scolarité',
  registration: 'Inscription',
  supplies: 'Fournitures',
  books: 'Livres',
  transport: 'Transport',
  uniform: 'Uniforme',
  uniforms: 'Uniformes',
  canteen: 'Cantine',
  exam: 'Examen',
  activity: 'Activité',
  message: 'Message',
  payment: 'Paiement',
  document: 'Document',
  action: 'Action',
  info: 'Info',
  receipt: 'Reçu',
  certificate: 'Certificat',
  reminder: 'Rappel',
  school: 'École',
  wallet: 'Portefeuille',
  file: 'Fichier',
  camera: 'Appareil photo',
  upload: 'Téléversement',
  scholarship: 'Bourse',
  broadcast: 'Diffusion',
  segment: 'Segment',
  single: 'Individuel',
  mobile: 'Mobile',
  system: 'Système',
  co_parent: 'Co-parent',
  family: 'Famille',
  public: 'Public',
  all_actions: 'Tous les besoins',
  selected_actions: 'Besoins sélectionnés',
  pay_declared: 'Paiement proposé',
  recommend: 'Recommandation',
  offer_help: 'Proposition d’aide',
  new: 'Nouvelle',
  accepted: 'Acceptée',
  declined: 'Refusée',
  financer: 'Financer',
  trouver: 'Trouver',
  aide: 'Aide',
  true: 'Oui',
  false: 'Non',
}

export const fieldLabels = {
  _id: 'Identifiant',
  userId: 'Parent',
  childId: 'Enfant',
  ownerUserId: 'Propriétaire',
  invitedUserId: 'Invité',
  plannerActionId: 'Action liée',
  resourceId: 'Ressource',
  actorType: 'Type d’acteur',
  actorEmail: 'Acteur',
  resourceType: 'Type de ressource',
  ip: 'Adresse IP',
  firstName: 'Prénom',
  phone: 'Téléphone',
  dialCode: 'Indicatif',
  name: 'Nom',
  email: 'Email',
  role: 'Rôle',
  status: 'Statut',
  statusKey: 'Statut',
  typeKey: 'Type',
  categoryKey: 'Catégorie',
  target: 'Cible',
  title: 'Titre',
  body: 'Message',
  content: 'Contenu',
  city: 'Ville',
  country: 'Pays',
  userCode: 'Code utilisateur',
  age: 'Âge',
  gender: 'Genre',
  classLevel: 'Classe',
  currentSchool: 'École actuelle',
  targetSchool: 'École cible',
  notes: 'Notes',
  note: 'Note',
  avatar: 'Avatar',
  assignee: 'Responsable',
  dueDate: 'Échéance',
  deadline: 'Échéance',
  estimatedAmount: 'Montant estimé',
  paidAmount: 'Montant payé',
  remainingAmount: 'Reste à payer',
  sharedCharge: 'Charge partagée',
  participants: 'Participants',
  paymentHistory: 'Historique de paiement',
  date: 'Date',
  sourceKey: 'Origine',
  amount: 'Montant',
  fileName: 'Nom du fichier',
  fileUrl: 'Lien du fichier',
  mimeType: 'Format du fichier',
  invitedUserCode: 'Code invité',
  category: 'Catégorie',
  actionScope: 'Portée',
  selectedActionIds: 'Actions sélectionnées',
  classLevels: 'Niveaux',
  budgetMin: 'Budget minimum',
  budgetMax: 'Budget maximum',
  description: 'Description',
  features: 'Atouts',
  requiredDocuments: 'Documents requis',
  contact: 'Contact',
  favoriteCount: 'Favoris',
  metadata: 'Métadonnées',
  sentAt: 'Envoyée le',
  createdAt: 'Créé le',
  updatedAt: 'Mis à jour',
  lastLoginAt: 'Dernière connexion',
  action: 'Action',
  type: 'Type',
  intent: 'Intention',
  supporterName: 'Soutien',
  supporterContact: 'Contact',
  needTitle: 'Besoin',
  contactRevealed: 'Contact révélé',
  sourceIp: 'Adresse IP',
  schoolStudentId: 'ID élève (école)',
  schoolName: 'École',
  studentName: 'Élève',
  logecode: 'Logecode',
  sharing: 'Partage',
  publicShareToken: 'Lien public (token)',
}

export function labelForValue(value) {
  if (value === null || value === undefined || value === '') return 'Non renseigné'
  return valueLabels[String(value)] || String(value)
}

export function labelForField(field) {
  if (!field) return ''
  return fieldLabels[field] || String(field).replace(/([A-Z])/g, ' $1').replace(/^./, char => char.toUpperCase())
}

export function option(value, label = labelForValue(value)) {
  return { value, label }
}

export function options(values) {
  return values.map(value => option(value))
}
